import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface Empresa {
  nit: string;
  nombre: string;
  estado: number;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class EmpresasService {
  private apiUrl =  `${environment.apiUrl}/api/empresas`; 

  constructor(private http: HttpClient) {}

  createEmpresa(empresa: Empresa): Observable<Empresa> {
    return this.http.post<Empresa>(this.apiUrl, empresa, { withCredentials: true }).pipe(
      catchError(error => {
        let message = 'Error en la solicitud.';
        if (error.status === 400 && error.error?.message === 'Este NIT ya está registrado.') {
          message = 'Este NIT ya está registrado.';
        }
        return throwError(() => new Error(message));
      })
    );
  }

  getEmpresas(): Observable<Empresa[]> {
    return this.http.get<Empresa[]>(this.apiUrl, { withCredentials: true }).pipe(catchError(this.handleError));
  }

  getEmpresaByNit(nit: string): Observable<Empresa> {
    return this.http.get<Empresa>(`${this.apiUrl}/${nit}`, { withCredentials: true }).pipe(catchError(this.handleError));
  }

  updateEmpresa(nit: string, empresa: Empresa): Observable<Empresa> {
    return this.http.put<Empresa>(`${this.apiUrl}/${nit}`, empresa, { withCredentials: true }).pipe(catchError(this.handleError));
  }

  inactivarEmpresa(nit: string): Observable<any> {
    return this.http.put(`${this.apiUrl}/${nit}/inactivar`, { estado: 0 }, { withCredentials: true }).pipe(catchError(this.handleError));
  }

  activarempresa(nit: string): Observable<any> {
    return this.http.put(`${this.apiUrl}/${nit}/activar`, { estado: 1 }, { withCredentials: true }).pipe(catchError(this.handleError));
  }

  getEmpresasCDA(): Observable<Empresa[]> {
    return this.http.get<Empresa[]>(`${this.apiUrl}/cda`, { withCredentials: true }).pipe(catchError(this.handleError));
  }

  getContratistas(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/contratista`, { withCredentials: true }).pipe(catchError(this.handleError));
  }

  getProveedores(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/proveedores`, { withCredentials: true }).pipe(catchError(this.handleError));
  }
  
 getContratistaPorUsuario(userId: number): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/api/usuario-contratista/usuario/${userId}`, { withCredentials: true }).pipe(catchError(this.handleError));

  }
  getTaller(): Observable<Empresa[]> {
    return this.http.get<Empresa[]>(`${this.apiUrl}/taller`, { withCredentials: true }).pipe(catchError(this.handleError));
  }

  getEPS(): Observable<any> {
    return this.http.get(`${this.apiUrl}/eps`, { withCredentials: true }).pipe(catchError(this.handleError));
  }

  getARL(): Observable<any> {
    return this.http.get(`${this.apiUrl}/arl`, { withCredentials: true }).pipe(catchError(this.handleError));
  }
  
  getEntidad(): Observable<any> {
    return this.http.get(`${this.apiUrl}/entidad`, { withCredentials: true }).pipe(catchError(this.handleError));
  }

  getAFP(): Observable<any> {
    return this.http.get(`${this.apiUrl}/afp`, { withCredentials: true }).pipe(catchError(this.handleError));
  }

  getCES(): Observable<any> {
    return this.http.get(`${this.apiUrl}/ces`, { withCredentials: true }).pipe(catchError(this.handleError));
  }

  getCCF(): Observable<any> {
    return this.http.get(`${this.apiUrl}/ccf`, { withCredentials: true }).pipe(catchError(this.handleError));
  }

  private handleError(error: any) {
    console.error('Ocurrió un error:', error);

    let message = error.message || 'Error en la solicitud.';

    if (error.status === 500 && error.error?.error?.name === "SequelizeUniqueConstraintError") {
      message = "Este NIT ya está registrado.";
    }

    return throwError(() => new Error(message));
  }

  getEDS(): Observable<Empresa[]> {
    return this.http
      .get<Empresa[]>(`${this.apiUrl}/eds`, { withCredentials: true }).pipe(catchError(this.handleError));
  }

  getAllEmpresasInactivas(): Observable<any> {
    return this.http.get(`${this.apiUrl}/inactivas`, { withCredentials: true }).pipe(catchError(this.handleError));
  }

 

  getEmpresasPorTipo(tipo: string, valor: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/${tipo}/${valor}`, { withCredentials: true }).pipe(catchError(this.handleError));
  }
}
